import { Box, Button, Grid, IconButton, InputLabel } from "@material-ui/core";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import React from "react";
import { useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CustomTextField from "../../../inputComponent/CustomTextField/CustomTextField";

export default function DistrictFields({
    classes,
    control,
    register,
    errors,
    exerciseIndex,
    getValues,
}) {
    const { t, i18n } = useTranslation();

    const { fields, remove, append } = useFieldArray({
        control,
        name: `exercise.${exerciseIndex}.district`,
    });
    return (
        <Grid container>
            <Grid item xs={3} className={classes.label}>
                {t("Form100.label.districtTitle")}
            </Grid>

            <Grid item xs={6}>
                {fields.map((district, districtIndex) => {
                    return (
                        <Box
                            display={"flex"}
                            key={districtIndex}
                            style={{ position: "relative" }}
                        >
                            <InputLabel
                                htmlFor={`exercise.${exerciseIndex}.district.${districtIndex}.enText`}
                                style={{
                                    display: "none",
                                }}
                            >
                                {t("common.portal.input")}
                            </InputLabel>
                            <CustomTextField
                                inputProps={{
                                    ...register(
                                        `exercise.${exerciseIndex}.district.${districtIndex}.enText`
                                    ),
                                    autoComplete: "off",
                                }}
                                placeholder={t(`common.en`)}
                                style={{
                                    marginRight: "10px",
                                }}
                                error={
                                    errors?.exercise?.[exerciseIndex]
                                        ?.district?.[districtIndex]?.enText
                                }
                            />
                            <InputLabel
                                htmlFor={`exercise.${exerciseIndex}.district.${districtIndex}.scText`}
                                style={{
                                    display: "none",
                                }}
                            >
                                {t("common.portal.input")}
                            </InputLabel>
                            <CustomTextField
                                inputProps={{
                                    ...register(
                                        `exercise.${exerciseIndex}.district.${districtIndex}.scText`
                                    ),
                                    autoComplete: "off",
                                }}
                                placeholder={t(`common.sc`)}
                                style={{
                                    marginRight: "10px",
                                }}
                                error={
                                    errors?.exercise?.[exerciseIndex]
                                        ?.district?.[districtIndex]?.scText
                                }
                            />
                            <InputLabel
                                htmlFor={`exercise.${exerciseIndex}.district.${districtIndex}.tcText`}
                                style={{
                                    display: "none",
                                }}
                            >
                                {t("common.portal.input")}
                            </InputLabel>
                            <CustomTextField
                                inputProps={{
                                    ...register(
                                        `exercise.${exerciseIndex}.district.${districtIndex}.tcText`
                                    ),
                                    autoComplete: "off",
                                }}
                                placeholder={t(`common.tc`)}
                                error={
                                    errors?.exercise?.[exerciseIndex]
                                        ?.district?.[districtIndex]?.tcText
                                }
                            />
                            {districtIndex !== 0 && (
                                <IconButton
                                    color="primary"
                                    onClick={() => {
                                        remove(districtIndex);
                                    }}
                                    style={{
                                        position: "absolute",
                                        right: "-45px",
                                        top: "-5px",
                                    }}
                                    aria-label="remove"
                                >
                                    <RemoveCircleIcon />
                                </IconButton>
                            )}
                        </Box>
                    );
                })}

                {fields.length < 5 && (
                    <Box mt={fields.length ? 2 : 4}>
                        <Button
                            onClick={() => {
                                append(
                                    { enText: "", scText: "", tcText: "" },
                                    { shouldFocus: false }
                                );
                            }}
                            variant="contained"
                            color="primary"
                            aria-label="add"
                        >
                            {t("common.button.append")}
                        </Button>
                    </Box>
                )}
            </Grid>
        </Grid>
    );
}
